var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Field',{staticClass:"consentMarketing",attrs:{"name":"marketing","type":"checkbox","value":_vm.value},on:{"update:value":function($event){return _vm.$emit('update:value', $event)}}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v(" "+_vm._s(_vm.$t('text'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }